export default class CategoryList {
    constructor() {
        this.BLOCK = null;
        this.BLOCK_STATE = { hiddenContent: null };
        this.AJAX_PARAM = null;
    }

    init(node) {
        // console.log('--init');
        this.BLOCK = node;

        this.BLOCK.addEventListener('click', this.handleCatetoryListClick);
    }

    destroy() {}

    handleCatetoryListClick = e => {
        let target = e.target;

        if (!target.classList.contains('category-list__item-cross')) {
            while (target !== this.BLOCK && !target.classList.contains('category-list__item')) {
                target = target.parentNode;
            }

            this.AJAX_PARAM = target.dataset.ajaxParam;

            if (this.AJAX_PARAM && this.AJAX_PARAM.length > 0) {
                this.createAndDispatchEvent();
            }
        }

        // wrap this code with special logic to prevent adding eventListeners outside chosen container
        if (target.classList.contains('category-list__item-cross')) {
            let target = e.target;
            this.AJAX_PARAM = target.dataset.ajaxParam;

            if (this.AJAX_PARAM && this.AJAX_PARAM.length > 0) {
                this.createAndDispatchEvent();
            }
        }
    };

    /**
     * Creates and dispatches custom event
     */
    createAndDispatchEvent() {
        let event = new CustomEvent('ajax-src-container-click', {
            bubbles: true,
            detail: { ajaxParam: this.AJAX_PARAM },
        });

        this.BLOCK.dispatchEvent(event);
        this.AJAX_PARAM = null;
    }
}
